export default __webpack_public_path__ + "static/media/cosmosBackground.ccbdfb81.svg";